import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ServiceAPI from '../../../service/ServiceAPI';
import HoseModel from '../../../model/HoseModel';
import LoadingIndicator from '../../utils/LoadingIndicator';
import { hasUserRole } from "../../../utils/AuthUtils"

import { Status as HoseStatus, Coupling as HoseCoupling, Material as HoseMaterial } from '../../../enums/HoseEnum';
import { Divider } from '@material-ui/core';
import { Container, Card, CardContent, Box, Typography, Grid, IconButton, Menu, MenuItem, Fab} from '@material-ui/core';
import { Chip, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TextField } from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import CouplingTypeIcon from '@material-ui/icons/SettingsInputCompositeTwoTone';
import DiameterIcon from '@material-ui/icons/StraightenTwoTone';
import MaterialIcon from '@material-ui/icons/LayersTwoTone';
import LengthIcon from '@material-ui/icons/HeightTwoTone';
import AddIcon from '@material-ui/icons/Add';
import Constants from '../../../utils/Constants';
import moment from 'moment';
import useErmaStyling from '../../../hooks/useErmaStyling';
import HoseStatusChip from './FragmentHoseStatus';
import DeleteConfirmDialog from '../../utils/FragmentDeleteConfirmDialog';
import ErmaResponsiveRecordGrid from '../../utils/ErmaResponsiveRecordGrid';
import ErmaResponsiveGridItem from '../../utils/ErmaResponsiveGridItem';


const HoseListing = () => {
  const ermaStyling = useErmaStyling();
  const navigate = useNavigate();

  const classes = ermaStyling.ermaStyles;
  const isMobile = ermaStyling.isMobile;
  
  const [hoses, setHoses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [error, setError] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedHose, setSelectedHose] = useState(null);
  const [searchValue, setSearchValue] = useState(null);
  const [filteredHoses, setFilteredHoses] = useState(null);
  
    
  useEffect(() => {
    fetchHoses();
  }, []);


  /**
   * Fetches the list of hoses from the API and updates the component state accordingly.
   */
  const fetchHoses = async () => {
    try {
      setLoading(true);

      ServiceAPI.HoseManagement().getHoses().then(
        hoseModels => {  
          setHoses(hoseModels);  
          setLoading(false);
        }
      );
      
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  /**
   * 
   */
  const handleClick_newHose = () => {
    let hose = new HoseModel();
    hose.setHoseName("");
    hose.setCouplingType(HoseCoupling.OTHER);
    hose.setMaterial(HoseMaterial.OTHER);
    hose.setDiameter(0);
    hose.setLengthM(0);
    hose.setStatus(HoseStatus.OUT_OF_SERVICE);
    hose.setInServiceDate(moment().format("YYYY-MM-DD"));
    
    ServiceAPI.HoseManagement().createHose(hose).then( (result) => {
      if (result.error) {
        // TODO: Need to do something to tell the user it didnt work.
        return;
      }

      navigate(Constants.RoutePath.HoseManagement.Edit(result.id));
    });
  }

  /**
   * Handles the opening of the action menu for a specific hose.
   * @param {*} event 
   * @param {*} hose 
   */
  const handleMenuOpen = (event, hose) => {
    setAnchorEl(event.currentTarget);
    setSelectedHose(hose);
  };

  /**
   * Handles the closing of the action menu and resets the selected hose.
   */
  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedHose(null);
  };

  /**
   * Handles the navigation to the Hose Test screen for the selecetd hose.
   */
  const handleClick_test = () => {
    navigate(Constants.RoutePath.HoseManagement.Test(selectedHose.getId()));
  }

  /**
   * Handles the navigation to the Hose History screen for the selected hose.
   */
  const handleClick_hoseHistory = () => {
    navigate(Constants.RoutePath.HoseManagement.History(selectedHose.getId()));
  }

  /**
   * Handles the Edit menu click event
   */
  const handleMenuEditClick = () => {
    navigate(Constants.RoutePath.HoseManagement.Edit(selectedHose.getId()));
  }

  /**
   * Handles the Delete menu click event
   */
  const handleMenuDeleteClick = (e) => {
    if (e !== null) {
      setShowDeleteConfirm(true);
      return;
    }

    setLoading(true);

    ServiceAPI.HoseManagement().deleteHose(selectedHose.getId()).then( (result) => {
      handleMenuClose();
      fetchHoses();
    })
  }

  /**
   * Handles the searching of the hose list for the user supplied value
   * @param {*} e 
   */
  const handleChange_searchValue = (e) => {
    let needle = e.target.value;
    let matches = [];

    setSearchValue(needle);

    if (needle.length < 1) {
      setFilteredHoses(null);
      return;
    }

    hoses.map((hose) => {
      let haystack = [
        hose.getHoseName(),
        hose.getMaterial(),
        hose.getCouplingType(),
        hose.getDiameter(),
        hose.getStatus()
      ]

      let haystackStr = haystack.join(",").toLowerCase();

      if (haystackStr.indexOf(needle.toLowerCase()) > -1) {
        matches.push(hose);
      }
    });

    setFilteredHoses(matches);
  }

  /**
   * The main render function for the HoseListing component.
   * @returns 
   */
  const render = () => {
    if ( !hasUserRole(Constants.UserRole.HoseManager) && !hasUserRole(Constants.UserRole.HoseUser) ) {
      navigate(Constants.RoutePath.Landing);
    }

    if (loading) {
      return <div><LoadingIndicator isOpen={true} /></div>;
    } 

    if (error) {
      return <div>Error: {error}</div>;
    } 

    return (
      <Container className={classes.container}>
        <Grid container justifyContent="space-between" className={classes.header}>
          <Grid item>
            <Typography className={classes.sectionHeading}>
              Hose Inventory
            </Typography>
          </Grid>
          <Grid item xs={12} sm={2}>
            <TextField label="Search hoses" type="search" variant="outlined" size="small" onChange={handleChange_searchValue} fullWidth/>
          </Grid>
        </Grid>

        { 
          /*isMobile
            ? renderMobileView(filteredHoses != null ? filteredHoses : hoses) 
            : renderDesktopView(filteredHoses != null ? filteredHoses : hoses) */
        }

        <Paper elevation={1}>
          <ErmaResponsiveRecordGrid rowKey={ r => r.getId() } records={(filteredHoses != null ? filteredHoses : hoses)} >
            <ErmaResponsiveGridItem
              label="ID" 
              noXsLabel
              xs={12} 
              sm={1} 
              element={ (r, l, m) => {
                if (!m) { return r.getId(); }
                return <Typography className={classes.label}>ID: {r.getId()}</Typography>
              }} 
              classes={{
                xs: [classes.gridTable_fieldAlignLeft],
                sm: [classes.gridTable_fieldAlignLeft]
              }}
            />

            <ErmaResponsiveGridItem
              label="Hose Name" 
              noXsLabel
              xs={12} 
              sm={2} 
              element={ (r, l, m) => {
                if (!m) { return r.getHoseName(); }
                return <span style={{fontSize: '3em'}}>{r.getHoseName()}</span>
              }}
              classes={{
                xs: [classes.gridTable_fieldAlignLeft],
                sm: [classes.gridTable_fieldAlignLeft]
              }}
            />

            <ErmaResponsiveGridItem
              label="Coupling" 
              noXsLabel
              xs={6} 
              sm={1} 
              element={ (r, l, m) => {
                if (!m) { return r.getCouplingType(); }
                return (
                  <Typography className={classes.value}>
                    <CouplingTypeIcon style={{marginRight: '.5em'}} />
                    {r.getCouplingType()}
                  </Typography>
                )
              }}
              classes={{
                xs: [classes.gridTable_fieldAlignLeft],
                sm: [classes.gridTable_fieldAlignLeft]
              }}
            />

            <ErmaResponsiveGridItem
              label="Diameter" 
              noXsLabel
              xs={6} 
              sm={1} 
              element={ (r, l, m) => {
                if (!m) { return (r.getDiameter() + "mm"); }
                return (
                  <Typography className={classes.value}>
                    <DiameterIcon style={{marginRight: '.5em'}} />
                    {r.getDiameter()}mm
                  </Typography>
                )
              }}
              classes={{
                xs: [classes.gridTable_fieldAlignLeft],
                sm: [classes.gridTable_fieldAlignLeft]
              }}
            />

            <ErmaResponsiveGridItem
              label="Length" 
              noXsLabel
              xs={6} 
              sm={1} 
              element={ (r, l, m) => {
                if (!m) { return (r.getLengthM() + "m"); }
                return (
                  <Typography className={classes.value}>
                    <LengthIcon style={{marginRight: '.5em'}} />
                    {r.getLengthM()}m
                  </Typography>
                )
              }}
              classes={{
                xs: [classes.gridTable_fieldAlignLeft],
                sm: [classes.gridTable_fieldAlignLeft]
              }}
            />

            <ErmaResponsiveGridItem
              label="Material" 
              noXsLabel
              xs={6} 
              sm={1} 
              element={ (r, l, m) => {
                if (!m) { return r.getMaterial(); }
                return (
                  <Typography className={classes.value}>
                    <MaterialIcon style={{marginRight: '.5em'}} />
                    {r.getMaterial()}
                  </Typography>
                )
              }}
              classes={{
                xs: [classes.gridTable_fieldAlignLeft],
                sm: [classes.gridTable_fieldAlignCenter]
              }}
            />

            <ErmaResponsiveGridItem
              label="In Service" 
              noXsLabel
              xs={12} 
              sm={1} 
              element={ (r,l,m) => {
                if (!m) { return r.getInServiceDate(); }
                return <Typography className={classes.label}>In Service Since: {r.getInServiceDate()}</Typography> 
              }}
              classes={{
                xs: [classes.gridTable_fieldAlignLeft],
                sm: [classes.gridTable_fieldAlignCenter]
              }}
            />

            <ErmaResponsiveGridItem
              label="Status" 
              noXsLabel
              xs={6} 
              sm={2} 
              element={ r => <HoseStatusChip hose={r} classes={classes} /> }
              classes={{
                xs: [classes.gridTable_fieldAlignCenter],
                sm: [classes.gridTable_fieldAlignCenter]
              }}
            />

            <ErmaResponsiveGridItem
              label="Actions" 
              noXsLabel
              xs={6} 
              sm={1} 
              element={ r => renderHoseActions(r) }
              classes={{
                xs: [classes.gridTable_fieldAlignRight],
                sm: [classes.gridTable_fieldAlignCenter]
              }}
            />
          </ErmaResponsiveRecordGrid>
        </Paper>

        <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
          <MenuItem onClick={handleClick_test}>Test</MenuItem>
          {false && <MenuItem>Repair</MenuItem>}
          <MenuItem onClick={handleClick_hoseHistory}>History</MenuItem>
          { 
            hasUserRole(Constants.UserRole.HoseManager) ? 
            [
              <MenuItem onClick={handleMenuEditClick}>Edit</MenuItem>,
              <Divider />,
              <MenuItem onClick={handleMenuDeleteClick} style={{color: "red"}}>Delete</MenuItem>,
            ] : null 
          }
        </Menu>

        { 
          hasUserRole(Constants.UserRole.HoseManager) &&
            <Fab color="primary" aria-label="New Hose" className={classes.fab} onClick={handleClick_newHose}>
              <AddIcon />
            </Fab>
        }

        <DeleteConfirmDialog
          show={showDeleteConfirm}
          handleDelete={handleMenuDeleteClick}
          tearDown={() => { handleMenuClose(); setShowDeleteConfirm(false); }}
        />
      </Container>
    );
  }

  /**
   * Renders the action buttons for a specific hose.
   * @param {*} hose 
   * @returns 
   */
  const renderHoseActions = (hose) => {
    return (
      <IconButton size="small" onClick={(e) => handleMenuOpen(e, hose)}>
        <MoreVertIcon />
      </IconButton>
    );
  }

  return render();
}      
  
export default HoseListing;